import { SystemService } from './../service/system.service';
import { Component, OnInit } from '@angular/core';
import { NotificationService } from '../service/notification.service';
import { BLocalStorageService } from '../service/bLocalStorage.service';
import { BTokenService } from '../service/bToken.service';

@Component({
 selector: 'app-root',
 template: `<router-outlet></router-outlet><bh-spinner></bh-spinner
 >`
})
export class LayoutComponent {

bLocalStorageService;
 bTokenService;
 systemS: SystemService;

constructor(private notificationService: NotificationService) {
   // this.notificationService.enableNotification();
   this.bLocalStorageService = new BLocalStorageService()
   this.bTokenService = new BTokenService();
   this.systemS = new SystemService();
 }

ngOnInit() {
   if (this.bLocalStorageService.getValue('accessToken')) {
     this.bTokenService.updateSessionStorage();
   }
 }
}


// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/layout/layout.component.ts